import { styled } from "@mui/material/styles";

export const LoginContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  backgroundColor: "var(--theme-gray-bg)",
});

export const LoginCard = styled("div")({
  backgroundColor: "var(--white)",
  border: "1px solid var(--border-color)",
  borderRadius: "var(--radius-xl)",
  padding: "var(--space-xxl)",
  width: "100%",
  maxWidth: "420px",
  boxShadow: "var(--shadow-md)",
  "@media (max-width: 480px)": {
    margin: "var(--space-md)",
    padding: "var(--space-xl)",
  },
});

export const LogoBox = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginBottom: "var(--space-xl)",
  gap: "var(--space-sm)",
});

export const Form = styled("form")({
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-md)",
});
